import { useApp } from "contexts/BookingContext";
import React, { useEffect, useRef } from "react";
import Swal from "sweetalert2";
import printJS from "print-js";
import { useAuth } from "hooks/useAuth";
import { Table } from "react-bootstrap";

const PrintBookingActivity = ({ booking, refetch, onSuccess, onError }) => {
  const printRef = useRef();
  const { user } = useAuth();
  console.log("PrintBookingActivity booking", booking);
  const today = new Date();
  const printDate = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  const printTime = today.toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) {
      Swal.fire("Error", "Print reference not found", "error");
      return;
    }

    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this booking?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          printJS({
            printable: printContent.innerHTML,
            type: "raw-html",
            targetStyles: ["*"],
            onPrintDialogClose: () => {
              Swal.fire({
                title: "Printing",
                text: "Booking is being processed...",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
              });

              if (onSuccess) {
                onSuccess();
              }

              if (refetch) {
                refetch();
              }
            },
          });
        } catch (error) {
          console.error("PrintJS Error:", error);
          Swal.fire("Error", "Failed to print booking", "error");
          if (onError) {
            onError();
          }
        }
      } else {
        Swal.fire("Cancelled", "Printing cancelled", "info");
      }
    });
  };

  useEffect(() => {
    if (booking) {
      handlePrint();
    }
  }, [booking]);

  return (
    <div>
      <button className="btn btn-sm btn-success" onClick={handlePrint}>
        Print
      </button>
      <div ref={printRef} style={{ display: "none" }}>
        <style>
          {`
          @media print {
            body {
              font-family: Arial, sans-serif;
              width: 58mm;
              padding: 5px;
            }
            .receipt {
              text-align: center;
              width: 100%;
              font-size: 14px;
            }
            .border-dashed {
              border-top: 1px dashed #000;
              margin: 8px 0;
            }
            table {
              width: 100%;
              font-size: 14px;
              border-collapse: collapse;
            }
            td, th {
              padding: 4px 0;
              text-align: left;
            }
            .right {
              text-align: right;
            }
            .center {
              text-align: center;
            }
          }
          `}
        </style>
        {/* Logo */}
        <div className="receipt">
          <img src="/Kuber.jpeg" alt="Logo" style={{ width: "50px" }} />
          <p>
            <strong>KUBER BALI ADVENTURE</strong>
          </p>
          <p>Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572</p>
          <div className="border-dashed"></div>
        </div>
        {/* Detail Booking */}
        <table>
          <tbody>
            <tr>
              <td>
                <strong>HOST</strong>
              </td>
              <td className="right" style={{ textTransform: "uppercase" }}>
                {user.name}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Code</strong>
              </td>
              <td className="right">{booking.code}</td>
            </tr>
            <tr>
              <td>
                <strong>Date</strong>
              </td>
              <td className="right">{booking.reservation_date}</td>
            </tr>
            <tr>
              <td>
                <strong>Print Date</strong>
              </td>
              <td className="right">{printDate}</td>
            </tr>
            <tr>
              <td>
                <strong>Print Time</strong>
              </td>
              <td className="right">{printTime}</td>
            </tr>
            <tr>
              <td>
                <strong>Guest</strong>
              </td>
              <td className="right">{booking.guest_name}</td>
            </tr>
            <tr>
              <td>
                <strong>Hotel</strong>
              </td>
              <td className="right">{booking.customer?.nationality}</td>
            </tr>
            <tr>
              <td>
                <strong>Agent</strong>
              </td>
              <td className="right">{booking.agent?.name || "N/A"}</td>
            </tr>
            <tr>
              <td>
                <strong>Driver</strong>
              </td>
              <td className="right">{booking.driver || "N/A"}</td>
            </tr>
            {/* transport */}
            <tr>
              <td>
                <strong>Transport</strong>
              </td>
              <td className="right">{booking.guest_transport || "N/A"}</td>
            </tr>
          </tbody>
        </table>
        <div className="border-dashed"></div>
        {/* Track */}
        <h2 className="center text-center align-middle m-0 p-0">
          {booking.track === "A" ? "PREMIUM" : "REGULAR"}
        </h2>
        {/* Detail Produk */}
        <table>
          <thead>
            <tr>
              <th>Activity</th>
              {/* <th className="right">Price</th> */}
              <th className="right">Qty</th>
            </tr>
          </thead>
          <tbody>
            {booking.activities.map((activity, index) => (
              <tr key={index}>
                <td>{activity.activity}</td>
                {/* <td className="right">
                  Rp. {parseInt(activity.price).toLocaleString("id-ID")}
                </td> */}
                <td className="right">{activity.qty}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Detail Pembayaran */}
        <div className="border-dashed"></div>
        <table>
          <tbody>
            {/* payment method */}

            <tr>
              <td>
                <strong>Total Guest</strong>
              </td>
              <td className="right">{booking.guest_pax}</td>
            </tr>
            <tr>
              <td>
                <strong>Payment Method</strong>
              </td>
              <td className="right">{booking.payment_method?.name || "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>Sub Total</strong>
              </td>
              <td className="right">
                Rp.{" "}
                {parseInt(booking.price_product_activities).toLocaleString(
                  "id-ID"
                )}
              </td>
            </tr>
            {/* tax */}
            <tr>
              <td>
                <strong>Tax {parseInt(booking.tax).toLocaleString("id-ID") || "-"}% </strong>
              </td>
              <td className="right">
                Rp.{" "}
                {(
                  (parseInt(booking.price_product_activities) *
                    parseInt(booking.tax)) /
                  100
                ).toLocaleString("id-ID")}
              </td>
            </tr>
            {/* total paid adalah price_product_activities yang dikondisikan dengan tax */}
            <tr>
              <td>
                <strong>Total Paid</strong>
              </td>
              <td className="right">
                Rp.{" "}
                {
                  // Check if tax exists, otherwise default to 0
                  (
                    parseInt(booking.price_product_activities) +
                    (booking.tax
                      ? (parseInt(booking.price_product_activities) *
                          parseInt(booking.tax)) /
                        100
                      : 0)
                  ).toLocaleString("id-ID")
                }
              </td>
            </tr>
          </tbody>
        </table>

        <div className="border-dashed"></div>
        <p className="receipt">
          <strong>Thank you for using our service!</strong>
        </p>
      </div>
    </div>
  );
};

export default PrintBookingActivity;
